<template>
  <div class="text-center div-bg">
    <b-row class="row-width">
      <b-col md="4" offset-md="3">
        <input class="input-email text-left" type="text" placeholder="请输入您的邮箱"><br/>
      </b-col>
    </b-row>
    <b-row class="row-width">
      <b-col md="4" offset-md="3">
        <!-- <input class="input-info text-left" type="text" placeholder="请输入您的意见反馈"> -->
        <textarea class="input-info" placeholder="请输入您的意见反馈"></textarea>
      </b-col>
      <b-col md="1">
        <button class="button">确认提交</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HomeContentFeedback'
}
</script>

<style lang="stylus" scoped>
.div-bg
  background-color #f1f1f1
  width 100%
  .row-width
    width 100%
  .input-email
    margin-top 3rem
    width 25.8rem
    height 3.8rem
  .input-info
    margin-top 2rem
    width 25.8rem
    height 7.9rem
    margin-bottom 3rem
  .button
    margin-top 6rem
    width 9.2rem
    height 3.3rem
    background-color #8b8b8b
    border-radius 0.3rem
    color #ffffff
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentFeedback.vue